import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.checkboxes.length
    ? _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(
                VCheckbox,
                _vm._g(
                  _vm._b(
                    {
                      model: {
                        value: _vm.dValue,
                        callback: function ($$v) {
                          _vm.dValue = $$v
                        },
                        expression: "dValue",
                      },
                    },
                    "VCheckbox",
                    { ..._vm.$attrs },
                    false
                  ),
                  _vm.$listeners
                )
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        "div",
        [
          _c(
            VInput,
            _vm._b(
              { attrs: { "hide-details": "" } },
              "v-input",
              { ..._vm.$attrs },
              false
            )
          ),
          _vm._v(" "),
          _c(
            "div",
            _vm._l(_vm.checkboxes, function (row, i) {
              return _c(
                VRow,
                { key: i },
                _vm._l(row, function (col) {
                  return _c(
                    VCol,
                    { key: col[_vm.itemValue] },
                    [
                      _c(
                        VCheckbox,
                        _vm._g(
                          _vm._b(
                            {
                              attrs: {
                                label:
                                  typeof col === "object"
                                    ? col[_vm.itemText]
                                    : col,
                                value:
                                  typeof col === "object"
                                    ? col[_vm.itemValue]
                                    : col,
                                "hide-details": "",
                              },
                              model: {
                                value: _vm.dValue,
                                callback: function ($$v) {
                                  _vm.dValue = $$v
                                },
                                expression: "dValue",
                              },
                            },
                            "VCheckbox",
                            { ..._vm.$attrs },
                            false
                          ),
                          _vm.$listeners
                        )
                      ),
                    ],
                    1
                  )
                }),
                1
              )
            }),
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }